/* eslint-disable wrap-iife */
/* eslint-disable max-statements, complexity, no-use-before-define */
(function($) {
  'use strict';
  $(document).ready(() => {
    var $tooltips = $('.tooltip'),
      tooltipThrottle = false;

    // Init tooltips if any found
    if ($tooltips.length > 0) {
      // Init tooltip positions
      $tooltips.each(function(index, elem) {
        checkXPosition($(elem));
      });

      $tooltips.on('click', 'a[href^="#"]', function(e) {
        var href = $(this).attr('href');
        window.location.hash = href;
        $(e.target)
          .closest('.tooltip')
          .find('.tooltip__popup')
          .removeClass('active')
          .attr('aria-hidden', 'true');
      });

      $tooltips.on('click', '.tooltip__toggle', function(e) {
        var $tooltip = $(e.target).closest('.tooltip');
        if ($tooltip.hasClass('tooltip--inline')) {
          return;
        }
        togglePopup($tooltip);
      });

      $tooltips.on('click', '.tooltip__close', function(e) {
        $(e.target)
          .closest('.tooltip')
          .find('.tooltip__popup')
          .removeClass('active')
          .attr('aria-hidden', 'true');
      });

      $tooltips
        .filter('.tooltip--inline')
        .on('mouseenter focus', '.tooltip__toggle', function(e) {
          $(e.target)
            .closest('.tooltip')
            .find('.tooltip__popup')
            .addClass('active')
            .attr('aria-hidden', 'false');
        })
        .on('mouseout', '.tooltip__toggle', function(e) {
          $(e.target)
            .closest('.tooltip')
            .find('.tooltip__popup')
            .removeClass('active')
            .attr('aria-hidden', 'true');
        });

      // detect tabbing away
      $tooltips.on('keydown', '.tooltip__toggle', function(e) {
        if (e.key === 'Tab' && e.shiftKey) {
          $(e.target)
            .closest('.tooltip')
            .find('.tooltip__popup')
            .removeClass('active')
            .attr('aria-hidden', 'true');
        }
      });
      $tooltips.each(function() {
        $(this)
          .find('button, a')
          .last()
          .on('keydown', function(e) {
            if (e.key === 'Tab' && !e.shiftKey) {
              $(e.target)
                .closest('.tooltip')
                .find('.tooltip__popup')
                .removeClass('active')
                .attr('aria-hidden', 'true');
            }
          });
      });

      // handle click outside
      $(document).on('click', function(event) {
        if (!$(event.target).closest('.tooltip').length) {
          $tooltips
            .find('.tooltip__popup')
            .removeClass('active')
            .attr('aria-hidden', 'true');
        }
      });

      // Init resize event
      $(window).on('resize', function() {
        if (!tooltipThrottle) {
          tooltipThrottle = true;

          $tooltips.each(function(index, elem) {
            checkXPosition($(elem));
          });

          this.setTimeout(function() {
            tooltipThrottle = false;
          }, 50);
        }
      });

      /**
       * Checks the position of the popup and determines if it needs to be aligned along the X axis
       * @param {jQuery} $tooltip
       */
      function checkXPosition($tooltip) {
        var $popup = $tooltip.find('.tooltip__popup');
        var offsetParent =
          $('body .parallax').length > 0
            ? $('body .parallax')
            : $tooltip.offsetParent();
        var bodyWidth = offsetParent.width(),
          bodyXOffset = offsetParent.offset().left,
          popupXOffset = $popup.length ? $popup.offset().left : null,
          popupXRange = $popup.length
            ? $popup.outerWidth() + popupXOffset
            : null;

        if (popupXOffset === null) {
          return;
        }

        {
          if (popupXRange > bodyWidth || popupXOffset < bodyXOffset) {
            calculateXPos($tooltip);
          } else {
            // Reset the position of the popup and arrow if within bounds
            resetPos($tooltip);
          }
        }
      }

      /**
       * Checks the position of the popup and determines if it needs to change position along the Y axis
       * @param {jQuery} $tooltip
       */
      function checkYPosition($tooltip) {
        var $popup = $tooltip.find('.tooltip__popup');
        var offsetParent =
          $('body .parallax').length > 0
            ? $('body .parallax')
            : $tooltip.offsetParent();
        var bodyHeight = offsetParent.height(),
          bodyYOffset = offsetParent.offset().top,
          popupYOffset = $popup.offset().top,
          popupYRange = $popup.outerHeight() + popupYOffset;

        if (popupYRange > bodyHeight) {
          // If popup is exceeds total height, change direction
          setDirection($tooltip, 'down');
        } else if (popupYOffset < bodyYOffset) {
          // If popup is too high, change direction
          setDirection($tooltips, 'up');
        }
      }

      /**
       * Calculates the X positioning for the popup of the tooltip
       * Direction is the attribute it will edit to shift the popup
       * @param {jQuery} $tooltip
       * @param {String} direction
       */
      // eslint-disable-next-line max-statements
      function calculateXPos($tooltip) {
        var offsetParent =
          $('body .parallax').length > 0
            ? $('body .parallax')
            : $tooltip.offsetParent();
        var tooltipXOffset = $tooltip.offset().left,
          tooltipXRange = $tooltip.outerWidth() + tooltipXOffset,
          $popup = $tooltip.find('.tooltip__popup'),
          bodyWidth = offsetParent.outerWidth();

        // Clear any previous shifts before applying new one
        $popup.removeClass('transition');
        $popup.removeAttr('style');

        var popupXOffset = $popup.offset().left,
          popupWidth = $popup.outerWidth(),
          popupXRange = popupWidth + popupXOffset,
          popupShift = 0;

        if (tooltipXOffset < popupXRange / 2) {
          // If there's not enough space on the left side of the popup, shift right
          // Shift the popup and arrow positions
          popupShift = tooltipXOffset * -1;
          $popup.css('left', popupShift + 'px');
          $popup.css('right', 'auto');
          $popup.addClass('transition');
          shiftArrow($tooltip, 'left', popupShift * -1 + 'px');
        } else if (bodyWidth - tooltipXRange < popupXRange / 2) {
          // If there's not enough on the right side of the tooltip for the popup, shift left
          // Shift the popup and arrow positions
          popupShift = (bodyWidth - tooltipXRange) * -1;
          $popup.css('right', popupShift + 'px');
          $popup.css('left', 'auto');
          $popup.addClass('transition');
          shiftArrow($tooltip, 'right', popupShift * -1 + 'px');
        } else {
          // If there is plenty of space either side, just reset tooltip position
          $popup.addClass('transition');
          resetPos($tooltip);
        }
      }

      /**
       * Shifts the position of the popup arrow so that it centres on the tooltip
       * Direction is the attribute it will edit and apply shift as the value
       * @param {jQuery} $tooltip
       * @param {String} direction
       * @param {Integer} shift
       */
      function shiftArrow($tooltip, direction, shift) {
        var $arrow = $tooltip.find('.tooltip__arrow');

        // Set auto for position shift
        $arrow.css('left', 'auto');
        $arrow.css('right', 'auto');

        $arrow.css(direction, shift);
      }

      /**
       * Removes the custom styles applied to the popup and arrow element
       * @param {jQuery} $tooltip
       */
      function resetPos($tooltip) {
        var offsetParent =
          $('body .parallax').length > 0
            ? $('body .parallax')
            : $tooltip.offsetParent();
        var $popup = $tooltip.find('.tooltip__popup'),
          $arrow = $tooltip.find('.tooltip__arrow'),
          popupStyle = $popup.attr('style'),
          arrowStyle = $arrow.attr('style');

        $popup.removeClass('transition');
        $popup.removeAttr('style');
        $arrow.removeAttr('style');

        // If after resetting the styles, they break, revert back
        var bodyWidth = offsetParent.width(),
          bodyXOffset = offsetParent.offset().left,
          popupXOffset = $popup.offset().left,
          popupXRange = $popup.outerWidth() + popupXOffset;

        if (popupXRange > bodyWidth || popupXOffset < bodyXOffset) {
          $popup.attr('style', popupStyle);
          $arrow.attr('style', arrowStyle);
        }
        $popup.addClass('transition');
      }

      /**
       * Toggles the popup of the tooltip
       * @param {jQuery} $tooltip
       */
      function togglePopup($tooltip) {
        var $popup = $tooltip.find('.tooltip__popup');
        var ariaHidden = $popup.attr('aria-hidden') === 'true';

        if (!$popup.hasClass('active')) {
          $tooltips
            .find('.tooltip__popup')
            .removeClass('active')
            .attr('aria-hidden', 'true');
          checkXPosition($tooltip);
          checkYPosition($tooltip);
        }

        $popup
          .toggleClass('active')
          .attr('aria-hidden', ariaHidden ? 'false' : 'true');
      }

      /**
       * Sets the direction the popup of the tooltip will transition in and out from
       * Valid directions are up, down, left and right
       * @param {jQuery} $tooltip
       * @param {String} direction
       */
      function setDirection($tooltip, direction) {
        var $popup = $tooltip.find('.tooltip__popup');

        $popup.removeClass('up down');
        $popup.addClass(direction);
      }
    }
  });
})(jQuery);
